import { TabItem, Tabs, docsTabsTheme } from '@acme/foundation';
import { ApplicationDocumentsTab } from './application/tab';
import { OrganizationDocumentsTab } from './organization/tab';

export const DocumentsPage = () => {
  const tabItems: TabItem[] = [
    {
      key: 'by-application',
      title: 'По заявкам',
      content: <ApplicationDocumentsTab />,
    },
    {
      key: 'by-organization',
      title: 'По организации',
      content: <OrganizationDocumentsTab />,
    },
  ];

  return (
    <div className="h-full">
      <Tabs
        items={tabItems}
        defaultActiveKey="by-application"
        theme={docsTabsTheme}
      />
    </div>
  );
};
